import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
    Dialog, DialogContent, DialogActions, Button, Grid,
    Typography, Select, MenuItem, Accordion, FormGroup, FormControlLabel,
    AccordionDetails, Checkbox, AccordionSummary, TextField
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { NumberSpinner } from 'components'
import { genfunction } from 'helpers'


const { OrderSubMenuPageOrderProductNoteText } = window['runConfig'];

const useStyles = makeStyles(theme => ({
    primarycolor: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    MenuImage: {
        width: 70,
        height: 70,
        maxWidth: 70,
        maxHeight: 70
    },
    button: {
        //borderRadius: 20
    }
}));

const OrderProduct = props => {
    const { open, Product, onCancel, onConfirm } = props;
    const classes = useStyles();
    let [product, SetProduct] = useState(JSON.parse(JSON.stringify(Product)));

    if (product && product.Quantity == undefined) {
        let objProduct = { ...product };
        objProduct.Quantity = 1;
        objProduct.ProductNotes = "";
        SetProduct(objProduct);
    }

    const onChangeSubOptionHandler = (optionProductID, option) => {
        let objProduct = { ...product };
        let o = objProduct.Options.find(o => o.OptionName === option.OptionName);
        if (option.IsRequired == true)
            o.Products = o.Products.map(p => { p.IsSelected = false; return p; })
        if (optionProductID && optionProductID != "") {
            let p = o.Products.find(p => p.ProductID == optionProductID);
            p.IsSelected = true;
        }
        SetProduct(objProduct);
    }

    const onChangeDeleteSubOptionHandler = (optionProductID, option) => {
        let objProduct = { ...product };
        let o = objProduct.Options.find(o => o.OptionName === option.OptionName);
        let p = o.Products.find(p => p.ProductID == optionProductID);
        p.IsSelected = false;
        SetProduct(objProduct);
    }

    const onClickQuantityChangeHandler = (ref, Quantity) => {
        let objProduct = { ...product };
        objProduct.Quantity = Quantity;
        SetProduct(objProduct);
    }

    const onChangeProductNoteHanlder = (text) => {
        let objProduct = { ...product };
        objProduct.ProductNotes = text;
        SetProduct(objProduct);
    }

    const getTotalPrice = () => {
        let optionPrice = 0;
        if (product.Options && product.Options.length > 0) {
            product.Options.forEach(option => {
                if (option.Products && option.Products.length > 0) {
                    option.Products.filter(p => p.IsSelected).forEach(p => {
                        optionPrice += genfunction.getOrderProductPrice(p);
                    });
                }
            });
        }
        return genfunction.getOrderProductPrice(product) + optionPrice;
    }

    const getOptionProductID = (option) => {
        let p;
        if (option && option.Products)
            p = option.Products.find(x => x.IsSelected == true);

        return p ? p.ProductID : "";
    }

    return (
        <Dialog
            open={open}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogContent>
                <Grid container spacing={1}>
                    <Grid container item xs={12}>
                        <Grid item xs={4}>
                            {product.ProductImageURL && product.ProductImageURL != "" ?
                                <img
                                    className={classes.MenuImage}
                                    width={'100%'}
                                    height={'100%'}
                                    alt="Logo"
                                    src={product.ProductImageURL && product.ProductImageURL != "" ? genfunction.replaceEscapeCharacters(product.ProductImageURL) : process.env.PUBLIC_URL + "/images/foodorder-placeholder.png"}
                                /> : <div className={classes.MenuImage}></div>}
                        </Grid>
                        <Grid item xs={8}>
                            <Typography variant="h5">{genfunction.replaceEscapeCharacters(product.ProductName)}</Typography>
                            <Typography variant="subtitle1">{genfunction.replaceEscapeCharacters(product.ProductDescription)}</Typography>
                        </Grid>
                    </Grid>

                    {product.Options && product.Options.length > 0 ?
                        product.Options
                            .filter(x => x.IsRequired == true)
                            .map(option => {
                                return (
                                    <Grid key={option.OptionName + "_options"} container item>
                                        <Grid container item xs={12}>
                                            <Grid item xs={6}>
                                                <Typography variant="h5">{genfunction.replaceEscapeCharacters(option.OptionName)} <Typography variant="caption">{option.IsRequired ? "(Required)" : "(Optional)"}</Typography></Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Select
                                                    fullWidth={true}
                                                    labelId={option.OptionName}
                                                    id={option.OptionName}
                                                    value={getOptionProductID(option)}
                                                    onChange={(event) => { onChangeSubOptionHandler(event.target.value, option) }}
                                                >
                                                    <MenuItem value="">
                                                        <em>None</em>
                                                    </MenuItem>

                                                    {option.Products && option.Products.length > 0 ?
                                                        option.Products.map(optionproduct => {
                                                            return (
                                                                <MenuItem key={optionproduct.ProductID + optionproduct.ProductName}
                                                                    value={optionproduct.ProductID}>
                                                                    {genfunction.replaceEscapeCharacters(optionproduct.ProductName) + (optionproduct.PriceIncTax > 0 ? (" " + genfunction.ccyFormat(genfunction.getOrderProductPrice(optionproduct))) : "")}
                                                                </MenuItem>
                                                            )
                                                        })
                                                        : ""}
                                                </Select>
                                            </Grid>
                                        </Grid>
                                    </Grid>)
                            })
                        : ""}

                    {product.Options && product.Options.filter(x => x.IsRequired == false).length > 0 ?
                        <Grid item xs={8}>
                            <Typography variant="h5">Optional Items</Typography>
                        </Grid> : ""}

                    {product.Options && product.Options.length > 0 ?
                        product.Options
                            .filter(x => x.IsRequired == false)
                            .map(option => {
                                return (
                                    <Grid key={option.OptionName + "_options"} item xs={12}>
                                        <Accordion>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                            >
                                                <Typography variant="h5">{genfunction.replaceEscapeCharacters(option.OptionName)}</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <Grid container spacing={1}>

                                                    {option.Products && option.Products.length > 0 ?
                                                        option.Products.map(optionproduct => {
                                                            return (
                                                                <Grid item xs={12}>
                                                                    <FormGroup>
                                                                        <FormControlLabel
                                                                            control={<Checkbox
                                                                                // value={getOptionProductID(optionproduct)}
                                                                                value={optionproduct.ProductID}
                                                                                checked={optionproduct.IsSelected}
                                                                                onChange={(event) => { optionproduct.IsSelected ? onChangeDeleteSubOptionHandler(event.target.value, option) : onChangeSubOptionHandler(event.target.value, option) }}
                                                                                name={optionproduct.ProductID} />}
                                                                            label={genfunction.replaceEscapeCharacters(optionproduct.ProductName) + (optionproduct.PriceIncTax > 0 ? (" " + genfunction.ccyFormat(genfunction.getOrderProductPrice(optionproduct))) : "")}
                                                                        /></FormGroup>
                                                                </Grid>
                                                            )
                                                        })
                                                        : ""}

                                                </Grid>


                                            </AccordionDetails>
                                        </Accordion>
                                    </Grid>
                                )
                            })
                        : ""}
                    {product.GetProductNotes ?
                        <Grid container item xs={12} spacing={1}>
                            <Grid item xs={12} align="left">
                                <Typography variant="h4">{OrderSubMenuPageOrderProductNoteText}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    value={product.ProductNotes}
                                    rows={4} variant="outlined" fullWidth={true} multiline={true}
                                    onChange={(event) => { onChangeProductNoteHanlder(event.target.value); }}
                                ></TextField>
                            </Grid>
                        </Grid>
                        : ""}

                    <Grid container item xs={12}>
                        <Grid item xs={6} align="left">
                            <Typography variant="h4">Total : {genfunction.ccyFormat(getTotalPrice() * product.Quantity)}</Typography>
                        </Grid>
                        <Grid item xs={6} align="right">
                            <NumberSpinner
                                refrence={{ eventId: 0, tourProductID: 0 }}
                                value={product.Quantity}
                                changeHandler={onClickQuantityChangeHandler}
                                minValue={1} maxValue={50}
                                steps={1}>
                            </NumberSpinner>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Grid container spacing={1}>
                    <Grid item xs={6} align="left">
                        <Button
                            onClick={onCancel}
                            className={classes.button}
                            color="primary" variant='outlined'>
                            Cancel
                        </Button>
                    </Grid>
                    <Grid item xs={6} align="right">
                        <Button
                            className={classes.button}
                            disabled={!genfunction.IsRequiredOptionsSelectedForOrderItem(product)}
                            onClick={() => { onConfirm(product); }}
                            color="primary" variant='contained'>
                            {product.UniqueID ? "Save" : "Add to cart"}
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog >
    );
};

OrderProduct.propTypes = {
    open: PropTypes.bool.isRequired
};

export default OrderProduct;
